export interface Faq {
  q: string
  a: string
}

export const faqs: Faq[] = [
  {
    q: 'How do I receive the package after purchasing?',
    a: "You'll receive access to all materials digitally after completing your purchase. No waiting, no shipping, no complicated steps.",
  },
  {
    q: 'What experience level do I need to use this?',
    a: 'The system covers foundational through advanced visual-art concepts and includes materials suitable for different student skill levels.',
  },
  {
    q: 'Does this work for art teachers in any country?',
    a: 'Yes. Art Teacher Ready focuses on broadly applicable visual-art techniques, principles, materials and classroom practices.',
  },
  {
    q: 'Can I edit and customize the material?',
    a: 'The material is delivered in finished PDF format.',
  },
  {
    q: 'What student levels does this cover?',
    a: 'Beginner, intermediate and advanced applications are included throughout the system.',
  },
  {
    q: 'What format is the material in?',
    a: 'Digital PDF format.',
  },
  {
    q: 'Are videos included?',
    a: 'No. The system focuses on PDF lessons, visual demonstrations, projects, worksheets and classroom resources.',
  },
  {
    q: "What if the material doesn't work for me?",
    a: 'You have a complete 7-day money-back guarantee.',
  },
]
